import script from "./IOrderMenu.vue?vue&type=script&setup=true&lang=js"
export * from "./IOrderMenu.vue?vue&type=script&setup=true&lang=js"

import "./IOrderMenu.vue?vue&type=style&index=0&id=e37affc8&lang=scss"

const __exports__ = script;

export default __exports__